import router from "@/router";
import { ref } from "@vue/composition-api";

export function useRoute() {
  const route = ref(router.currentRoute);

  router.beforeEach((to, from, next) => {
    route.value = to;
    next();
  });

  return route;
}

export function useRouter() {
  return router;
}
